import React from "react";
import FadeReveal from "./FadeReveal";

const stats = [
  { value: "3+", label: "Years coding" },
  { value: "5+", label: "Projects shipped" },
  { value: "2", label: "Hackathons" },
  { value: "1", label: "Cybersecurity cert" },
];

const Stats = () => {
  return (
    <section id="stats" aria-label="Quick facts">
      <div className="shell">
        <FadeReveal direction="up" delay={0.05}>
          <div className="stats-grid">
            {stats.map((stat) => (
              <div key={stat.label} className="stat">
                <span className="stat-value">
                  {stat.value.replace("+", "")}
                  {stat.value.includes("+") && <em>+</em>}
                </span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </FadeReveal>
      </div>
    </section>
  );
};

export default Stats;
